module.exports = __webpack_public_path__ + "static/img/2.0564aea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/services/2.jpg
// module id = b/lo
// module chunks = 0